import type { Action } from 'redux'
import type { StreamDefinition } from '../../../signalr/types'
import { defaultGetParams as getParams } from '../../../signalr/helpers'
import { queueStatsAddQueueStats } from './actions'
import type { QueueStats } from './types'

export const fetchQueueStatsDefinition: StreamDefinition<
  [],
  QueueStats[],
  Action
> = {
  method: 'GetQueueStats',
  strategy: 'switch',
  getParams,
  mapResponse: queueStatsAddQueueStats,
  errorAction: 'queueStats.fetchFail',
  cancelOn: []
}
